import { combineReducers } from "redux";
import userReducer from "./user";
import errorsReducer from "./errors";
import studentReducer from "./student";
import mapReducer from "./map";
import TAQTReducer from "./taqt";
import VHReducer from "./vh";
import examReducer from "./exam";
import vanhoalessonsReducer from "./vanhoalessons";
import vanhoaReducer from "./vanhoa";
import ieltsReducer from "./ielts";
import roadmapReducer from "./roadmap";
import PHHSReducer from "./phhs";

const rootReducer = combineReducers({
  user: userReducer,
  errors: errorsReducer,
  student: studentReducer,
  map: mapReducer,
  taqt: TAQTReducer,
  vh: VHReducer,
  exam: examReducer,
  vanhoalessons: vanhoalessonsReducer,
  vanhoa: vanhoaReducer,
  ielts: ieltsReducer,
  roadmap: roadmapReducer,
  phhs: PHHSReducer,
});

export default rootReducer;
